import { useMutation } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

export interface CreateEventInput {
  name?: string
  description?: string
  accomplish_statement?: string
  expectation_statement?: string
  status: string
  organized_by: string
  maximum_attendees?: number
  color?: string
  keywords?: string[]
  grade_levels?: string[]
  content_areas?: string[]
  engagement_opportunities?: string[]
  connection_preference?: string[]
  dates?: {
    dates?: {
      start: string
      end: string
    }[]
    times?: {
      start: string
      end: string
    }[]
  }
  location?: {
    address?: string
    city?: string
    state?: string
    zip?: string
    virtual?: boolean
    url?: string
  }
  archived?: boolean
  open?: boolean
  flexible_dates?: boolean
  flexible_times?: boolean
  flexible_location?: boolean
  invite_all_educators?: boolean
  invite_all_professionals?: boolean
  invited_users?: string[]
  secondaryLanguages?: string[]
}

export interface CreateEventResponse {
  id: string
  name: string
  description: string
  status: string
  keywords?: string[]
  // Other fields returned by the API
}

const API_URL =
  import.meta.env.VITE_EPC_API_URL ?? import.meta.env.REACT_APP_API_URL ?? ''

export const useCreateEventMutation = () => {
  const fetchWithAuth = useFetchWithAuth()
  return useMutation<CreateEventResponse, Error, CreateEventInput>({
    mutationFn: async (eventData) => {
      const response = await fetchWithAuth(`${API_URL}/events`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(eventData),
      })
      return response
    },
  })
}
